import type { ComponentProps } from 'react';

/**
 * Componente para usar con un boton/link muy pequeño para hacer que el area de pulsado sea mas grande.
 * Idealmente solo es necesario pasarle una clase de *size* o *height* y *width* y usar con parent *relative*
 */
export function TouchTarget({
  className,
  hideOnFinePointer = true,
  ...rest
}: ComponentProps<'span'> & {
  hideOnFinePointer?: boolean;
}) {
  return (
    <span
      {...rest}
      className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 ${hideOnFinePointer ? '[@media(pointer:fine)]:hidden' : ''} ${className}`}
    />
  );
}
